import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    height: "25px",
    width: "25px",
    background: "#D8D8D8",
    border: "0",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
}));

export default function IconButtonDatatable({ children, ...rest }) {
  const classes = useStyles();
  return (
    <button type='button' className={classes.root} {...rest}>
      {children}
    </button>
  );
}
